import React from "react";
import { getPathWithParam } from "../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSackDollar,
  faClipboardList,
  faUser,
} from "@fortawesome/pro-solid-svg-icons";
import { Col, Row } from "react-bootstrap";

const PendingApprovalCard = ({ history, pendingApproval }) => {
  const PendingRequestCard = () => {
    return (
      <div className="d-flex flex-column ptb-20 justify-content-center align-items-center mt-3 mb-3">
        <div className="pending-approval-card-icon">
          <FontAwesomeIcon
            icon={
              pendingApproval?.label == "Loan Requests"
                ? faSackDollar
                : pendingApproval?.label == "Withdrawal Requests"
                ? faClipboardList
                : faUser
            }
            size="lg"
          />
        </div>
        <div className="ft-16 fw-500 mt-2">{pendingApproval?.count ?? 0}</div>
        <div className="ft-14 fw-400 mt-2">{pendingApproval?.label}</div>
      </div>
    );
  };

  return (
    <div
      className="pending-approval-card cursor-pointer"
      onClick={() => {
        history.push(
          getPathWithParam({
            path: pendingApproval.link,
          })
        );
      }}
    >
      {pendingApproval?.label == "Loan Requests" ? (
        <Row>
          <Col sm={8} className="loan-border-right">
            {PendingRequestCard()}
          </Col>
          <Col sm={4}>
            <div className="ft-12 justify-content-center align-items-center ptb-20">
              <div className="approval-card-label">New</div>
              <div>{pendingApproval?.newLoanCount}</div>
              <div className="border-bottom p-0 mt-1 mb-2" />
              <div className="approval-card-label">ReAmortize</div>
              <div>{pendingApproval?.reAmortizeCount}</div>
              <div className="border-bottom p-0 mt-1 mb-2" />
              <div className="approval-card-label">ReFinance</div>
              <div>{pendingApproval?.reFinanceCount}</div>
            </div>
          </Col>
        </Row>
      ) : (
        PendingRequestCard()
      )}
    </div>
  );
};

export default PendingApprovalCard;
